import Joyride from "react-joyride";
import React from "react";

export class Tour extends React.Component {
  render() {
    const { steps } = this.props;
    return (
      <>
        <Joyride
          steps={steps}
          locale={{
            close: "Got it!",
          }}
          styles={{
            options: {
              arrowColor: "#fff",
              backgroundColor: "#fff",
              overlayColor: "rgb(48 49 54 / 47%)",
              primaryColor: "#3753B8",
              textColor: "#004a14",
              width: 350,
              zIndex: 1000
            },
            tooltipFooter: {
              marginTop: 0
            }
          }}
        />
      </>
    );
  }
}
